import { Component, Input } from '@angular/core';

export interface CrosshairOhlc {
  open: number | null;
  high: number | null;
  low: number | null;
  close: number | null;
  change: number | null;
  changePct: number | null;
}

export interface LegendItem {
  id: string;
  name: string;
  color: string;
  value: string;
  lastValue: string;
}

/**
 * Leyenda OHLC (con % de cambio) + leyenda de indicadores, como overlay del chart.
 * Extraído de grafica-modelo para reutilizarse también en multicharts-dialog,
 * reemplazando la construcción manual de HTML que tenía multicharts.
 */
@Component({
  selector: 'app-chart-legend',
  templateUrl: './chart-legend.component.html',
  styleUrls: ['./chart-legend.component.scss'],
})
export class ChartLegendComponent {
  @Input() symbolLabel: string = '';
  @Input() timeframeLabel: string = '';
  /** Fecha/hora de la vela bajo el cursor (o de la última vela). Opcional — usado por multicharts-dialog. */
  @Input() dateLabel: string = '';
  @Input() crosshairOhlc: CrosshairOhlc | null = null;
  /** Bid/Ask en vivo (opcional) — usado por multicharts-dialog. */
  @Input() bid: number | null = null;
  @Input() ask: number | null = null;
  @Input() legendItems: LegendItem[] = [];
  @Input() isDark: boolean = false;
  /** Condición de entrada/salida legible (mismo dato que grafica-modelo: ln → setCondicionLegible). */
  @Input() condicionEntradaLista: string[] = [];
  @Input() condicionSalidaLista: string[] = [];
  /** false en celdas pequeñas (mosaico de multicharts) donde el bloque no cabe. */
  @Input() showCondiciones: boolean = true;
}
